<template>
  <div class="outer-container">
    <div class="inner-container">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.outer-container {
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100dvh;
  min-width: 375px;
}

.inner-container {
  margin-inline: 1rem;
}

@container (width >= calc(600px + 2rem)) {
  .inner-container {
    min-width: 600px;
    margin: 0 auto;
  }
}
</style>
